export default __webpack_public_path__ + "static/media/temaiken-logo.d00c4b72.png";